import React, { useState } from "react";
import { useUserRole } from "../../../context/UserRoleContext";
import { useBar } from "../../../context/BarContext";
import DashboardLayout from "../../../components/common/DashboardLayout";
import Overall from "../components/financials/Overall";
import ByArtist from "../components/financials/ByArtist";

const Financials = () => {
  const { userData, loading } = useUserRole();
  const { selectedBar } = useBar();
  const [activeTab, setActiveTab] = useState("overall");

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  const tabs = [
    { id: "overall", label: "Overall", icon: "📊" },
    { id: "by-artist", label: "By Artist", icon: "🎤" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "overall":
        return <Overall />;
      case "by-artist":
        return <ByArtist />;
      default:
        return <Overall />;
    }
  };

  return (
    <DashboardLayout>
      <div className="bar-owner-dashboard">
        {/* Tab Selector */}
        <div className="tab-selector">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </DashboardLayout>
  );
};

export default Financials;
